import { filesize } from 'filesize';
import { useAtom } from 'jotai';
import { startCase } from 'lodash';
import { useMemo } from 'react';

import KeyValue from '@/components/KeyValue';
import {
  levelFormatter,
  rulesDetailsAtom,
  type SensorRuleLevelDTO
} from '@/pages/Administration/AdministrationRules';
import { selectedOrganizationIdAtom } from '@/pages/Organizations';

const RulesFileDetails = () => {
  const [rulesDetails] = useAtom(rulesDetailsAtom);
  const [selectedOrganizationId] = useAtom(selectedOrganizationIdAtom);

  const keyValueItems = useMemo(() => {
    return [
      {
        label: 'File Name',
        value: rulesDetails?.file_name
      },
      {
        label: 'File Size',
        value:
          rulesDetails &&
          filesize(rulesDetails.size as number, { standard: 'jedec' })
      },
      {
        label: 'File Type',
        value: startCase(rulesDetails?.file_type)
      },
      {
        label: 'Level',
        value: levelFormatter(rulesDetails?.level as SensorRuleLevelDTO)
      },
      ...(selectedOrganizationId === 0
        ? [
            {
              label: 'Organization',
              value: rulesDetails?.organization
            }
          ]
        : [])
    ];
  }, [rulesDetails, selectedOrganizationId]);

  return <KeyValue items={keyValueItems} />;
};

export default RulesFileDetails;
